import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchScormFiles } from '../../apis/scormUpload';

// Async thunk to fetch scorm files
export const fetchScormFilesThunk = createAsyncThunk('scormFiles/fetchScormFiles', async (page = 1, { rejectWithValue }) => {
    try {
        const res = await fetchScormFiles(page);
        // If the API returns .data.results, return that, else return []
        return Array.isArray(res.data?.results) ? res.data.results : [];
    } catch (err) {
        return rejectWithValue(err);
    }
});

const scormFilesSlice = createSlice({
    name: 'scormFiles',
    initialState: {
        files: [],
        loading: false,
        error: null,
        hasCompletedExtraction: false,
        scormFileIdForChatbot: null,
    },
    reducers: {
        addScormFile: (state, action) => {
            // Add new file to the top of the list
            state.files = [action.payload, ...state.files];
        },
        deleteScormFile: (state, action) => {
            // Remove file by id
            state.files = state.files.filter((file) => file.id !== action.payload);
        },
        setHasCompletedExtraction: (state, action) => {
            state.hasCompletedExtraction = action.payload;
        },
        setScormFileIdForChatbot: (state, action) => {
            state.scormFileIdForChatbot = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchScormFilesThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchScormFilesThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.files = action.payload;
            })
            .addCase(fetchScormFilesThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch SCORM files';
            });
    },
});

export const { addScormFile, deleteScormFile, setHasCompletedExtraction, setScormFileIdForChatbot } =
    scormFilesSlice.actions;
export default scormFilesSlice.reducer;
